<template>
    <aside class="side-menu">
        <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasmenu" aria-labelledby="offcanvasExampleLabel" aria-modal="true" role="dialog">  
            <div class="offcanvas-body">
                <div class="sidebar-details">
                    <div class="sidebar-menu left-open-menu">
                        <div class="offcanvas-header header-menu-sec">
                            <div class="sidebar-menu-logo-sec">
                                <router-link :to="{name:'Home'}" aria-label="sidebar logo">
                                    <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="sidebar-logo">
                                </router-link>
                                <!-- <a href="#">
                                    <img loading="lazy" src="@/assets/images/logo-inplay.webp" alt="">
                                </a> -->
                            </div>
                            <button ref="sidemenu_close" type="button" class="btn-close" data-bs-dismiss="offcanvas"
                                aria-label="Close" v-show="false">x</button>
                            <!-- <div class="offcanvas-title" id="offcanvasExampleLabel">
                                <div class="recent-bank-sec1">
                                    <div class="thm-heading">
                                        <h2>{{ this.userData?.userid }}</h2>
                                        <p>{{ $t('last-login','Last Login')}}: {{ this.userData?.last_login_at }}</p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="user_copy_field">
                            <span class="user_name">{{ $auth?.user?.userid }}</span>
                            <button type="button" class="user_copy_btn" @click="copyUserId()">
                                <img loading="lazy" src="@/assets/images/copy-icon.webp" alt="copy-img">
                            </button>
                        </div>
                        <div class="open-side-menu-sec">
                            <ul class="acc-open-menu">
                                <!-- <li>
                                    <div class="menu-details-heading">
                                        <h4>{{ $t('setting','Setting')}}</h4>
                                    </div>
                                    <div class="menu-heading-con" style="display: contents;">
                                        <div v-if="clickBetCheck && getClickBetSelectedValue()" data-bs-toggle="modal"
                                            data-bs-target="#clickBetValue">
                                            <label>{{ getKFormatter(getClickBetSelectedValue()) }}</label>
                                        </div>
                                        <div class="form-check form-switch m-0 p-0">
                                            <input class="form-check-input" v-model="clickBetCheck"
                                                @change="betCheckChangeFunc()" type="checkbox" id="settingCheckDefaults">
                                            <label class="form-check-label" for="flexSwitchCheckDefaults">{{ $t('one-click-bet','One Click Bet')}}</label>                                                
                                        </div>
                                        <a style="display: none;" ref="open_click_bet_value" data-bs-toggle="modal"
                                            data-bs-target="#clickBetValue"></a>
                                    </div>
                                </li>
                                <li>
                                    <a href="#" class="w-100 bonus-box">
                                        <div class="wallet-balance-sec">
                                            <div class="menu-details-heading">
                                                <h4>{{ $t('wallet-balance','Wallet balance')}}</h4>
                                            </div>
                                            <div class="menu-details-heading">
                                                <h4><span class="profit-color border-0"> {{ this.userData?.balance
                                                }}</span></h4>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <div class="menu-details-heading">
                                        <h4>{{ $t('exposure','Exposure')}}</h4>
                                    </div>
                                    <div class="menu-details-heading">
                                        <h4><span class="loss-color"> {{ this.userData?.exposure }}</span></h4>
                                    </div>
                                </li> -->
                                <li data-bs-dismiss="offcanvas">
                                    <a href="javascript:void(0)" class="onclick_bet_btn">
                                        <div class="dis-flex-space">
                                            <span>{{ $t('one-click-bet','One Click Bet')}}</span>
                                            <div class="menu-heading-con" style="display: contents;">
                                                <div class="form-check form-switch ">
                                                    <input class="form-check-input" v-model="clickBetCheck"
                                                    @change="betCheckChangeFunc()" type="checkbox" id="settingCheckDefaults"  aria-label="bet Check Change ">
                                                </div>
                                            </div>
                                            <div data-bs-toggle="modal"
                                            data-bs-target="#clickBetValue">
                                                <span v-if="clickBetCheck && getClickBetSelectedValue()">{{ getClickBetSelectedValue() }}</span>
                                            </div>                                             
                                            <span style="display: none;" ref="open_click_bet_value" data-bs-toggle="modal"
                                                data-bs-target="#clickBetValue"></span>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <div class="menu-details-heading">
                                        <h3>{{ $t('wallet-balance','Wallet balance')}}</h3>
                                    </div>
                                    <div class="menu-details-heading">
                                        <h4><span class="profit-color border-0"> {{ $helper.formatNumber($auth?.user?.balance || 0)}}</span></h4>
                                    </div>
                                </li>
                                <li>
                                    <div class="menu-details-heading">
                                        <h3>{{ $t('exposure','Exposure')}}</h3>
                                    </div>
                                    <div class="menu-details-heading">
                                        <h4><span class="loss-color"> {{$helper.formatNumber($auth?.user?.expl ? (-1) * $auth?.user?.expl : 0)  }}</span></h4>
                                    </div>
                                </li>
                                <li v-if="$siteSettings?.data?.business_type == 2">
                                    <div class="bonusBx-wrap" v-if="lockedEarnedData">

                                        <div class="menu-details-heading bonus_info_sec" href="#informationModal" data-bs-toggle="modal">
                                            <h4>{{$t('bonus-information', 'Bonus Information')}}</h4>
                                            <span class="information-icon">
                                                <button type="button" class="info_modal_bonus" @click="getRules()">
                                                    <img loading="lazy" src="@/assets/images/info-icon.svg" alt="" />
                                                </button>
                                            </span>
                                        </div>

                                        <div class="bonus_cmn_head">
                                            <div class="bonus_title1">
                                                <h5>{{$t('earned-bonus', 'Earned Bonus')}}</h5>
                                                <h6>{{ lockedEarnedData.earnBonus }}</h6>
                                            </div>
                                        </div>
                                        
                                        <div class="welcome-locked-bx">
                                            <div class="bonus_cmn_head">
                                                <div class="bonus_title1">
                                                    <h4>{{$t('welcome-bonus', 'Welcome Bonus')}}</h4>
                                                    <h6>
                                                        <strong>{{ lockedEarnedData.welcomeBonus }}</strong>
                                                    </h6>
                                                </div>
                                            </div>
                                            <div class="play_with_bonus_title">
                                                <div class="play_with_bonus">
                                                    <h4>{{$t('play-with-bonus', 'Play with Bonus')}}</h4>
                                                </div>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="settingCheckDefaults"  v-model="getWalletType" @change="updateWalletType"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="earn_and-earn_sec">
                                            <div class="locked_bonus">
                                                <a href="Javascript:void(0);" class="locked-bonus-btn" @click="openBonusLogs()">{{$t('locked-bonus', 'Locked Bonus')}} <span>{{ lockedEarnedData.lockedBonus }}</span></a>
                                            </div>
                                            <div class="refer_and_earn_link" v-if="$siteSettings?.data?.business_type == 2">
                                                <router-link to="/refer-earn" @click="closeSideBar()">
                                                    <img loading="lazy" src="@/assets/images/refer_and_earn.png" alt="refer-user">
                                                    <span>{{ $t('refer-&-earn-bonus','Refer & Earn Bonus')}}</span>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                
                                
                                <!-- <li v-if="$siteSettings?.data?.business_type == 2">
                                    <router-link to="/refer-earn" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/refer-user.webp" alt="refer-user">
                                        <span>{{ $t('refer-&-earn-bonus','Refer & Earn Bonus')}}</span>
                                    </router-link>
                                </li> -->

                                <li>
                                    <router-link :to="{ name: 'Inplay' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/home.webp" alt="home">
                                        <span>{{ $t('home','Home')}}</span>
                                        
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'Profile' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/profile.webp" alt="profile">
                                        <span>{{ $t('my-profile','My Profile')}}</span>
                                    </router-link>
                                </li>
                              
                                <li>
                                    <router-link :to="{ name: 'MultiMarket' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/multi.webp" alt="multi">
                                        <span>{{ $t('multi-markets','Multi Markets')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'profit-loss' }"
                                        @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/profitloss.webp" alt="profitloss">
                                        <span>{{ $t('profit-loss','Profit Loss')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'AccountStatement' }"
                                        @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/statement.webp" alt="statement">
                                        <span> {{ $t('ac-statement','A/C Statements')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'unsettled-bets' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/bets.webp" alt="bets">
                                        <span>{{ $t('un-settled-bets','Un-Settled Bets')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'settled-bets' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/settled-icons.af308012.svg" alt="bets">
                                        <span>{{ $t('settled-bets','Settled Bets')}}</span>
                                    </router-link>
                                </li>
                                <li data-bs-dismiss="offcanvas">
                                    <a data-bs-toggle="modal" data-bs-target="#language_selection_pop_up"
                                        >
                                        <img loading="lazy" src="@/assets/images/laguage_icon.webp" alt="language-list-icon">
                                        <span>{{ $t('language','Language')}}</span>
                                    </a>
                                </li>
                                 
                                <li class="notification_icon">
                                    <router-link :to="{ name: 'Notifications' }"  @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/notification-icon.svg" alt="notification">
                                        <span> {{ $t('notificatons','Notifications')}}</span>
                                    </router-link>

                                </li>
  
                                <li>
                                    <router-link :to="{ name: 'Rules' }"  @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/terms.webp" alt="terms">
                                        <span> {{ $t('rules','Rules')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'EditStakes' }" @click="closeSideBar()">
                                        <img loading="lazy" src="@/assets/images/edit.webp" alt="edit">
                                        <span>{{ $t('edit-stake','Edit Stakes')}}</span>
                                    </router-link>
                                </li>
                                
                                <li>
                                    <a class="multi-mark-bg" href="#install-apk-model" data-bs-toggle="modal">
                                        <img loading="lazy" src="@/assets/images/project-apk-icon.webp" alt="project-apk-icon">
                                        <span>{{ $t('download-apk','Download APK')}}</span>
                                    </a>
                                </li>
                                
                                <li>
                                    <a class="multi-mark-bg logout-bg" href="javascript:void(0);" @click="closeSideBar(),toggleTheme()">
                                        <img loading="lazy" src="@/assets/images/contrast.svg" alt="contrast">
                                        <span> {{ $t('mode','Mode')}}: <span id="mode">{{ $t(currentTheme.toLowerCase() , currentTheme) }}</span></span>
                                    </a>
                                </li>
                                <li>
                                    <a data-bs-toggle="modal" data-bs-target="#logoutmodal" class=" logout-bg">
                                        <img loading="lazy" src="@/assets/images/logout.webp" alt="">
                                        <span class="logout-span"> {{ $t('logout','logout')}}</span>
                                    </a>
                                </li>
                            </ul>
                            <template v-if="this.$siteSettings?.data?.business_type == 2">
                            <div class="sicail_link_login_sec">
                                <div class="socail_icon_list">
                                    <h4>{{$t('social-link', 'Social Link')}}</h4>
                                <ul>
                                    <li>
                                        <a v-if="$siteSettings?.data?.social_link?.whatsappno1" :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank">
                                            <img loading="lazy" src="@/assets/images/whatsapp-share-new.svg" alt="whatsapp-share">
                                        </a>
                                    </li>
                                    <li>
                                        <a v-if="$siteSettings?.data?.social_link?.telegram_link" :href="$siteSettings?.data?.social_link?.telegram_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/telegram-share-new.svg" alt="telegram">
                                        </a>
                                    </li>
                                    <li>
                                        <a v-if="$siteSettings?.data?.social_link?.instagram_link" :href="$siteSettings?.data?.social_link?.instagram_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/instagram-share-new.svg" alt="instagram">
                                        </a>
                                    </li>
                                    <li>
                                        <a v-if="$siteSettings?.data?.social_link?.facebook_link" :href="$siteSettings?.data?.social_link?.facebook_link" target="_blank">
                                            <img loading="lazy" src="@/assets/images/facebook-share-new.svg" alt="facebook">
                                        </a>
                                    </li>
                                </ul>
                                    
                                </div>
                            </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </aside>

    <DownloadApkModal></DownloadApkModal>

    <LockedBonus v-if="showBonusLogs"  @closeBonusLogs="closeBonusLogs()"></LockedBonus>

    <ClickBetModal  @close-modal="closeClickBetModal" ref="clickBetModal"/>

    <ChangePassword @close="closeModal()"  />
    <CreditReference />
    <div class="modal fade modal-footer-sticky" ref="siteRulesModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <RulesModal :siteRuleData='siteRuleData' />
    </div>
    <BonusInformation :siteRuleData="siteRuleData" />
    <LogoutModal @close_sidebar="closeSideBar()"  />
    <LanguageSelection />
</template>
<script>
import { kFormatter } from '@/shared/utils/formatter';
import { mapGetters } from 'vuex';

import { defineAsyncComponent } from 'vue';
export default {
    name: "Account",
    data() {
        return {
            userData: null,
            themeSelection: false,
            clickBetCheck: false,
            themeName: '',
            siteRuleData: null,
            showStakeModal: false,
            lockedEarnedData: null,
            showBonusLogs: false,
            getWalletType: false
        }
    },
    computed: {
        ...mapGetters([
             'stateUser', 'isAuthenticated'
        ]),
        currentTheme(){
            return this.$root.$themeState.currentTheme;
        }
    },
    components: {
        BonusInformation: defineAsyncComponent(() => import('./BonusInformation.vue')),
        ChangePassword: defineAsyncComponent(() => import('./ChangePassword.vue')),
        CreditReference: defineAsyncComponent(() => import('./CreditReference.vue')),
        RulesModal: defineAsyncComponent(() => import('./RulesModal.vue')),
        ClickBetModal: defineAsyncComponent(() => import('./ClickBetModal.vue')),
        LogoutModal: defineAsyncComponent(() => import('./LogoutModal.vue')),
        DownloadApkModal: defineAsyncComponent(() => import('@/shared/components/modal/DownloadApkModal.vue')),
        LockedBonus: defineAsyncComponent(() => import('./LockedBonus.vue')),
        LanguageSelection: defineAsyncComponent(() => import('@/shared/components/header/LanguageSelection.vue'))
        //Translator
    },
    mounted() {
        // this.one_click_bet_value = this.$store.getters.clickBetValue ? [...this.$store.getters.clickBetValue] : null;
        // this.clickBetCheck=this.$store.getters.clickBetCheck
        if (this.$store.getters.clickBetActive) {
            this.clickBetCheck = true
        }
        this.userData = this.$store?.getters?.stateUser;
        //for add on all APIs
        if (localStorage.getItem('default_class')) {
            this.themeName = localStorage.getItem('default_class');
        }
        if(this.isAuthenticated && this.$siteSettings?.data.business_type == 2) {
            this.getLockedEarnedBonus();
            this.getWalletType = this.stateUser?.activeWallet == 'WB' ?? 0;
        }
    },
   
    methods: {
        toggleTheme(){
            this.$root.$toggleTheme();
        },
        getGlobaLoader() {
            return this.$store.getters.globalLoader;
        },
        betCheckChangeFunc() {
            if (this.clickBetCheck) {
                // this.$store.dispatch('setClickBetCheck',this.clickBetCheck)
                this.$refs.open_click_bet_value.click();
            }
            else {
                let valueInputs = this.$store.getters.clickBetValue;
                valueInputs.forEach(item => {
                    item.isSelected = false
                })
                this.$store.dispatch('setClickBetValue', valueInputs);
                this.$refs.clickBetModal.resetSelectedValue()
            }
        },
        closeModal() {
            this.$refs.close_button.click();
        },
        closeSideBar(){
            this.$refs.sidemenu_close.click();
        },
        closeStakeModal() {
            this.showStakeModal = false;
        },
        getClickBetValue() {
            return this.$store.getters.clickBetValue ? [...this.$store.getters.clickBetValue] : null;
        },

        // getClickBetSelectedValue() {
        //     let inputValues = this.getClickBetValue();
        //     if (inputValues)
        //         return inputValues.filter(item => item.isSelected)[0]?.value;
        // },
        getClickBetSelectedValue() {
            if (this.getClickBetValue()) {
                let inputValues = JSON.parse(JSON.stringify([...this.getClickBetValue()]));
                if(this.$store.getters.clickBetActive) {
                    if (inputValues)
                        return inputValues.filter(item => item.isSelected)[0].value;
                }
            }
        },
        getKFormatter(num) {
            return kFormatter(num);
        },

        setTheme(theme) {
            this.themeName = theme;
            localStorage.setItem('default_class', theme)
            document.documentElement.className = theme;
            this.themeSelection = false;
        },

        showErrorModalFunc(message) {
            this.$errorToast(message);
        },
        showSuccessModalFunc(message) {
            this.$successToast(message);
        },

        getRules() {
            let ruleResp = this.$siteSettings?.data?.rules;
            this.siteRuleData = {}
            ruleResp.forEach(item => {
                this.siteRuleData[item.type] = item.content;
            })
        },
        getWalletGetway() {
            this.$router.push({name: 'wallet'});
        },
        getLockedEarnedBonus() {
             this.$apiCall('get', 'GET_LOCKED_EARNED_BONUS', null, 'bonus').then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast( response.data.debug[0]);
                        }
                        else {
                            this.lockedEarnedData = response.data.data;
                            this.lockedEarnedData.earnBonus = this.$auth.user.earnBonus;
                            this.$store.dispatch('setUserBonus', this.lockedEarnedData);
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast( error[0]);
                }
            });
        },
        openBonusLogs() {
            this.showBonusLogs = true;
        },
        closeBonusLogs() {
            setTimeout(() => {
                this.showBonusLogs = false;
            }, 400)
        },
        updateWalletType() {
            this.$apiCall('post','UPDATE_WALLET_TYPE', {}).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast( response.data.debug[0]);
                            this.getWalletType = !this.getWalletType
                        }
                        else {
                            let user = this.stateUser;
                            user.activeWallet = response.data.data.active_wallet;
                            this.$store.dispatch('setUser', user);
                            this.$successToast( this.$t('success-changed','Successfully changed'));
                            setTimeout(() => {
                                this.$emit('updateAuthToken', true);
                            },2000)
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.getWalletType = !this.getWalletType
                    this.$errorToast( error[0]);
                }
            });
        },
        closeClickBetModal(clickBetCheckValue) {
                this.clickBetCheck= clickBetCheckValue
        },
        async copyUserId(){
            try {
                await navigator.clipboard.writeText(this.$auth?.user?.userid);
                this.$successToast(this.$t('userid-copied-succ','User ID Copied Successfully.'));
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
    },

};
</script>

<style scoped>
.width-100 {
    display: block !important;
    width: 100% !important;
    padding: 0px !important;
}

</style>